import { render } from "./qui_sommes_nous.vue?vue&type=template&id=c140c2f8"
import script from "./qui_sommes_nous.vue?vue&type=script&lang=js"
export * from "./qui_sommes_nous.vue?vue&type=script&lang=js"

import "./qui_sommes_nous.vue?vue&type=style&index=0&id=c140c2f8&lang=css"

import exportComponent from "C:\\Users\\bodin\\Documents\\projects\\lescouleursdelavie\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__